export default __webpack_public_path__ + "static/media/intro_pics.6ddfe64c.png";